<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">묻고 답하기</p>
          <ul class="depth">
            <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
            <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
            <li><router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">묻고 답하기</h3>
        <article>
          <div class="table horizontal-table noticeView">
            <table>
              <caption>
                묻고 답하기 상세 테이블
              </caption>
              <colgroup>
                <col style="width: 20%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="2">
                    <div class="tableTitle">
                      <p class="tit">{{ inquiry.title }}</p>
                      <div class="right">
                        <span class="writer">{{ inquiry.writer }}</span>
                        <span class="date">{{ inquiry.createdate }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="tableCont">
                    <pre name="" id="">
                                            {{ inquiry.content }}
                                        </pre
                    >
                  </td>
                </tr>
                <tr v-if="attachList">
                  <th scope="row">첨부파일</th>
                  <td>
                    <article class="input-style button interval">
                      <div class="attach">
                        <div class="file-name">
                          <span
                            class="cursor"
                            @click="
                              downloadAttachFile(
                                attachList.filePath,
                                attachList.saveNm,
                                attachList.viewNm,
                                attachList.fileExt,
                                attachList.repoId,
                              )
                            "
                          >
                            {{ attachList.viewNm }} ({{ attachList.fileSize | comma }})kb
                          </span>
                        </div>
                      </div>
                    </article>
                  </td>
                </tr>
                <tr>
                  <th scope="row">답변</th>
                  <td>
                    <pre name="" id="">
                                            {{ answer.content }}
                                        </pre
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="linkMove">
            <a @click="prevView" :class="{ disabled: prevIs }" class="prev"><p>이전글로 이동합니다.</p></a>
            <a @click="nextView" :class="{ disabled: nextIs }" class="next"><p>다음글로 이동합니다.</p></a>
          </div>
        </article>
        <article class="btnArea">
          <button type="button" class="btn border" @click="$router.push('qnalist')">목록</button>
        </article>
      </div>
    </section>
    <popup v-show="showModal">
      <template #info> 비밀번호 입력 </template>
      <template #content>
        <article class="paragraph">
          <p>비밀번호를 입력 해 주세요.</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                비밀번호 입력 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">비밀번호</th>
                  <td>
                    <input type="password" title="비밀번호 입력" v-model="password" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn blue" @click="chkPw">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </popup>
    <alert-notmatch v-show="showModalMsgFailure">
      <template #content>
        <p>{{ msg1 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CancleBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-notmatch>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import Popup from '../../../components/PopupType1.vue';
import AlertNotmatch from '../../../components/Alert02.vue';
import _ from 'lodash';

export default {
  data() {
    return {
      inquiryId: '',
      inquiry: {},
      answer: {},
      pw: '',
      attachList: '',
      prev: '',
      next: '',
      prevIs: false,
      nextIs: false,
      password: '',
      showModal: false,
      showModalMsgFailure: false,
      msg1: '비밀번호가 맞지 않습니다.',
      inquiryViewNext: '',
      inquiryViewPrev: '',
    };
  },

  components: {
    Popup,
    AlertNotmatch,
  },

  mounted() {
    const inquiryId = this.$route.query.inquiryId;
    const auth = this.$route.query.viewAuthChk;
    //   if(!(inquiryId || auth)) {
    // alert("잘못된 접근입니다.");
    // this.$router.push('/qnalist');
    //       return;
    //   }
    if (inquiryId === undefined || !auth) {
      alert('잘못된 접근입니다.');
      this.$router.push('/qnalist');
      return;
    } else if (inquiryId !== '' && auth) {
      this.inquiryId = inquiryId;
      this.findInquiry();
    }
  },

  methods: {
    async findInquiry() {
      this.prev = '';
      this.next = '';
      const apiParams = new FormData();
      apiParams.append('inquiryId', this.inquiryId);
      const res = await axios('post', '/api/inquiry/view', apiParams);
      const data = res.data;
      this.inquiry = data.inquiryView;
      this.attachList = data.attachList[0];
      if (this.inquiry.answer) {
        this.answer = data.answer;
      }
      if (data.inquiryViewNext != null && data.inquiryViewPrev == null) {
        this.next = data.inquiryViewNext.inquiryId;
      } else if (data.inquiryViewPrev != null && data.inquiryViewNext == null) {
        this.prev = data.inquiryViewPrev.inquiryId;
      } else if (data.inquiryViewNext == null && data.inquiryViewPrev == null) {
        this.prev = '';
        this.next = '';
      } else {
        this.next = data.inquiryViewNext.inquiryId;
        this.prev = data.inquiryViewPrev.inquiryId;
      }
      this.inquiryViewPrev = data.inquiryViewPrev;
      this.inquiryViewNext = data.inquiryViewNext;
      if (this.prev == '' && this.next != '') {
        this.prevIs = true;
        this.nextIs = false;
      } else if (this.prev != '' && this.next == '') {
        this.prevIs = false;
        this.nextIs = true;
      } else if (this.prev == '' && this.next == '') {
        this.prevIs = true;
        this.nextIs = true;
      } else {
        this.prevIs = false;
        this.nextIs = false;
      }
    },

    view(stts) {
      stts == 'prev' ? 'prev' : 'next';
      if (this.nextIs) {
        return;
      }
      this.inquiryId = this.inquiryViewNext.inquiryId;
      if (this.inquiryViewNext.nondisclosure) {
        this.showModal = true;
      } else {
        this.$router.push({
          path: 'qnaView',
          query: { inquiryId: this.inquiryId, viewAuthChk: true },
        });
        this.findInquiry();
      }
    },

    prevView() {
      if (this.prevIs) {
        return;
      }
      this.inquiryId = this.inquiryViewPrev.inquiryId;
      if (this.inquiryViewPrev.nondisclosure) {
        this.showModal = true;
      } else {
        this.$router.push({
          path: 'qnaView',
          query: { inquiryId: this.inquiryId, viewAuthChk: true },
        });
        this.findInquiry();
      }
    },

    nextView() {
      if (this.nextIs) {
        return;
      }
      this.inquiryId = this.inquiryViewNext.inquiryId;
      if (this.inquiryViewNext.nondisclosure) {
        this.showModal = true;
      } else {
        this.$router.push({
          path: 'qnaView',
          query: { inquiryId: this.inquiryId, viewAuthChk: true },
        });
        this.findInquiry();
      }
    },

    downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
      location.href =
        '/api/inquiry/download.json?filePath=' +
        filePath +
        '&saveNm=' +
        saveNm +
        '&viewNm=' +
        viewNm +
        '&fileExt=' +
        fileExt +
        '&repoId=' +
        repoId;
    },

    async chkPw() {
      const apiParams = new FormData();
      apiParams.append('inquiryId', this.inquiryId);
      apiParams.append('password', this.password);
      const res = await axios('post', '/api/inquiry/pwChk', apiParams);
      this.showModal = false;
      this.password = '';
      if (!res.data?.result) {
        this.showModalMsgFailure = true;
        return;
      } else {
        await this.$router.push({
          path: 'qnaView',
          query: { inquiryId: this.inquiryId, viewAuthChk: true },
        });
        this.findInquiry();
      }
    },

    CancleBtn() {
      this.showModalMsgFailure = false;
      this.showModal = false;
    },
  },
};
</script>
